import React, { useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Input, InputLabel, Button } from "@mui/material";
import { FormControl } from "@mui/material";
import { ThemeModeContext, contentBoxStyle } from "../shared/Theme";
import { Link, useParams } from "react-router-dom";
import userService from "../services/userService";
import { validPassword } from "../shared/sharedFunctions";
import alertService from "../services/alertService";

const Invite = () => {
	
	const { token } = useParams();
	const navigate = useNavigate();
	
	const themeModeContext = useContext(ThemeModeContext);
	const imageUrls = {
		"light": "/cymplify-logo_light.png",
		"dark": "/cymplify-logo_dark.png",
	}
	const imageUrl = imageUrls[themeModeContext.themeMode];
	
	const password = useRef(null);
	const confirmPassword = useRef(null);

	const handleSubmit = (e) => {
		e.preventDefault();
		
		let passwordValue = (password.current)? password.current.value : null;
		let confirmPasswordValue = (confirmPassword.current)? confirmPassword.current.value : null;
		
		if (!validPassword(passwordValue)) {
			if (password.current) password.current.value = "";
			if (confirmPassword.current) confirmPassword.current.value = "";
			
			let msg = `Invalid password\n`;
			msg += `Password must be at least 8 characters and contain at least 1 uppercase, 1 lowercase,`;
			msg += `1 number and 1 special character`;
			return alertService.show(msg);
		}
		
		if (passwordValue !== confirmPasswordValue) {
			if (password.current) password.current.value = "";
			if (confirmPassword.current) confirmPassword.current.value = "";
			return alertService.show(`Password and confirmation do not match`);
		}
		
		userService.resetPassword(token, passwordValue, confirmPasswordValue)
		.then(() => {
			if (password.current) password.current.value = "";
			if (confirmPassword.current) confirmPassword.current.value = "";
			
			navigate("/");
			return;
		})
		.catch((err) => {
			console.log(err.message);
			if (password.current) password.current.value = "";
			if (confirmPassword.current) confirmPassword.current.value = "";
			return alertService.show(`Error setting new password`);
		});
	};

	const formControlStyle = {
		width: "80%",
		maxWidth: "35em",
		margin: "1em auto",
		display: "flex",
		lexDirection: "row",
		flexGrow: 1
	};
	
	return (
		<Box sx={{ display: "flex" }}>
			<Box component="main" sx={{flexGrow: 1, bgcolor: "background.default"}}>
				<Box sx={contentBoxStyle}>
					<Box sx={{
						height: "30em",
						width: "25em",
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)"
					}}>
						<Box sx={{ textAlign: "center" }}>
							<Link to="/">
								<img src={imageUrl} alt="cymplify logo" />
							</Link>
						</Box>
						<Box sx={{ textAlign: "center", marginTop: "3em", marginBottom: "1em" }}>
							<Typography>Please set your Cymplify account password</Typography>
						</Box>
						<form onSubmit={handleSubmit}>
							<FormControl sx={formControlStyle}>
								<InputLabel htmlFor="password">Password</InputLabel>
								<Input inputRef={password} id="password" type="password"/>
							</FormControl>
							<FormControl sx={formControlStyle}>
								<InputLabel htmlFor="confirmPassword">Confirm Password</InputLabel>
								<Input inputRef={confirmPassword} id="confirmPassword" type="password"/>
							</FormControl>
							<FormControl sx={formControlStyle}>
								<Button type="submit" label="Set Password">Set Password</Button>
							</FormControl>
						</form>
					</Box>
				</Box>
			</Box>
		</Box>
	);
}

export default Invite;
